import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const DragIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><circle cx="10" cy="8" r="1" fill="currentColor" /><circle cx="10" cy="12" r="1" fill="currentColor" /><circle cx="10" cy="16" r="1" fill="currentColor" /><circle cx="14" cy="16" r="1" fill="currentColor" /><circle cx="14" cy="12" r="1" fill="currentColor" /><circle cx="14" cy="8" r="1" fill="currentColor" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DragIcon;